import _ from 'lodash';
import {
  FETCH_ALL_ORDER_TRANSACTION,
  FETCH_ALL_ORDER_TRANSACTION_SUCCEED,
  FETCH_ALL_ORDER_TRANSACTION_FAILED,
  FETCH_USER_ORDER_TRANSACTIONS_SUCCEED,
  WS_EVENT_UPDATE_ORDER_TRANSACTION,
  WS_EVENT_UPDATE_BATCH_ORDER_TRANSACTION,
  FETCH_ID_ORDER_TRANSACTIONS_SUCCEED,
} from '../actions/order_transaction/action_types';
import utils from '../../common/utils';

function transformData(data) {
  _.forEach(data, (item) => {
    item.key = item.id;
    item.pair = `${item.coin}/${item.currency}`.toUpperCase();
    item.style = {
      width: '2%',
      backgroundColor: `${item.transaction_type == window.c.ORDER_TRADE_TYPE_BUY ? 'rgba(22,177,87,0.61)' : 'rgba(240,83,89,0.6)'}`,
    };
    item.created_at = utils.formatTimeFromUnix(item.created_at, 'DD/MM/YYYY HH:mm:ss');
  });
}

export default (state = {
  orderTransactions: [],
  userOrderTransactions: [],
  idOrderTransactions: [],
  isTableLoading: false,
}, action) => {
  switch (action.type) {
    case FETCH_ALL_ORDER_TRANSACTION:
      return {
        ...state,
        isTableLoading: true,
      };
    case FETCH_ALL_ORDER_TRANSACTION_SUCCEED:
      transformData(action.params.data);

      return {
        ...state,
        orderTransactions: action.params.data,
        isTableLoading: false,
      };
    case FETCH_USER_ORDER_TRANSACTIONS_SUCCEED:
      transformData(action.params.data);

      return {
        ...state,
        userOrderTransactions: _.forEach(action.params.data, (item) => {
          item.key = item.id;
        }),
      };

    case FETCH_ALL_ORDER_TRANSACTION_FAILED:
      return {
        ...state,
        isTableLoading: false,
        orderTransactions: [],
      };
    case WS_EVENT_UPDATE_ORDER_TRANSACTION:
      if (state.orderTransactions.length > 50) {
        state.orderTransactions.pop();
      }
      transformData([action.data]);

      return {
        ...state,
        orderTransactions: [action.data, ...state.orderTransactions],
      };
    case WS_EVENT_UPDATE_BATCH_ORDER_TRANSACTION:
      const newOrderTrans = state.orderTransactions;
      if (newOrderTrans.length > 50) {
        newOrderTrans.slice(action.data.length - 1, 50);
      }

      transformData(action.data);
      return {
        ...state,
        orderTransactions: [...action.data, ...newOrderTrans],
      };
    case FETCH_ID_ORDER_TRANSACTIONS_SUCCEED:
      transformData(action.params.data);
      return {
        ...state,
        idOrderTransactions: action.params.data,
      };
    default:
      return {
        ...state,
      };
  }
};
